export const flex_row =`
.flex-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
}
`;
export const flex_column =`
.flex-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
}
`;
export const flex_row_reverse =`
.flex-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
}
`;
export const flex_column_reverse =`
.flex-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
}
`;
export const flex_wrap =`
.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}
`;
export const flex_nowrap =`
.flex-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
}
`;
export const flex_wrap_reverse =`
.flex-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
}
`;
export const flex_fill =`
.flex-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
}
`;
export const flex_grow_0 =`
.flex-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
}
`;
export const flex_grow_1 =`
.flex-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
}
`;
export const flex_shrink_0 =`
.flex-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
}
`;
export const flex_shrink_1 =`
.flex-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
}
`;
export const justify_content_start =`
.justify-content-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
}
`;
export const justify_content_end =`
.justify-content-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
}
`;
export const justify_content_center =`
.justify-content-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
}
`;
export const justify_content_between =`
.justify-content-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
}
`;
export const justify_content_around =`
.justify-content-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
}
`;
export const align_items_start =`
.align-items-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
}
`;
export const align_items_end =`
.align-items-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
}
`;
export const align_items_center =`
.align-items-center {
    -ms-flex-align: center !important;
    align-items: center !important;
}
`;
export const align_items_baseline =`
.align-items-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
}
`;
export const align_items_stretch =`
.align-items-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
}
`;
export const align_content_start =`
.align-content-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
}
`;
export const align_content_end =`
.align-content-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
}
`;
export const align_content_center =`
.align-content-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
}
`;
export const align_content_between =`
.align-content-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
}
`;
export const align_content_around =`
.align-content-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
}
`;
export const align_content_stretch =`
.align-content-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
}
`;
export const align_self_auto =`
.align-self-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
}
`;
export const align_self_start =`
.align-self-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
}
`;
export const align_self_end =`
.align-self-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
}
`;
export const align_self_center =`
.align-self-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
}
`;
export const align_self_baseline =`
.align-self-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
}
`;
export const align_self_stretch =`
.align-self-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
}
`;
export const flex_sm_row =`
@media (min-width: 576px) {
    .flex-sm-row {
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }
}
`;
export const flex_sm_column =`
@media (min-width: 576px) {
    .flex-sm-column {
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }
}
`;
export const flex_sm_row_reverse =`
@media (min-width: 576px) {
    .flex-sm-row-reverse {
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }
}
`;
export const flex_sm_column_reverse =`
@media (min-width: 576px) {
    .flex-sm-column-reverse {
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }
}
`;
export const flex_sm_wrap =`
@media (min-width: 576px) {
    .flex-sm-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
}
`;
export const flex_sm_nowrap =`
@media (min-width: 576px) {
    .flex-sm-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }
}
`;
export const flex_sm_wrap_reverse =`
@media (min-width: 576px) {
    .flex-sm-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }
}
`;
export const flex_sm_fill =`
@media (min-width: 576px) {
    .flex-sm-fill {
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
    }
}
`;
export const flex_sm_grow_0 =`
@media (min-width: 576px) {
    .flex-sm-grow-0 {
        -ms-flex-positive: 0 !important;
        flex-grow: 0 !important;
    }
}
`;
export const flex_sm_grow_1 =`
@media (min-width: 576px) {
    .flex-sm-grow-1 {
        -ms-flex-positive: 1 !important;
        flex-grow: 1 !important;
    }
}
`;
export const flex_sm_shrink_0 =`
@media (min-width: 576px) {
    .flex-sm-shrink-0 {
        -ms-flex-negative: 0 !important;
        flex-shrink: 0 !important;
    }
}
`;
export const flex_sm_shrink_1 =` 
@media (min-width: 576px) {
    .flex-sm-shrink-1 {
        -ms-flex-negative: 1 !important;
        flex-shrink: 1 !important;
    }
}
`;
export const justify_content_sm_start =`
@media (min-width: 576px) {
    .justify-content-sm-start {
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }
}
`;
export const justify_content_sm_end =`
@media (min-width: 576px) {
    .justify-content-sm-end {
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }
}
`;
export const justify_content_sm_center =`
@media (min-width: 576px) {
    .justify-content-sm-center {
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }
}
`;
export const justify_content_sm_between =`
@media (min-width: 576px) {
    .justify-content-sm-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
}
`;
export const justify_content_sm_around =`
@media (min-width: 576px) {
    .justify-content-sm-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }
}
`;
export const align_items_sm_start =`
@media (min-width: 576px) {
    .align-items-sm-start {
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }
}
`;
export const align_items_sm_end =`
@media (min-width: 576px) {
    .align-items-sm-end {
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }
}
`;
export const align_items_sm_center =`
@media (min-width: 576px) {
    .align-items-sm-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
}
`;
export const align_items_sm_baseline =`
@media (min-width: 576px) {
    .align-items-sm-baseline {
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }
}
`;
export const align_items_sm_stretch =`
@media (min-width: 576px) {
    .align-items-sm-stretch {
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }
}
`;
export const align_content_sm_start =`
@media (min-width: 576px) {
    .align-content-sm-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }
}
`;
export const align_content_sm_end =`
@media (min-width: 576px) {
    .align-content-sm-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }
}
`;
export const align_content_sm_center =`
@media (min-width: 576px) {
    .align-content-sm-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }
}
`;
export const align_content_sm_between =`
@media (min-width: 576px) {
    .align-content-sm-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }
}
`;
export const align_content_sm_around =`
@media (min-width: 576px) {
    .align-content-sm-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }
}
`;
export const align_content_sm_stretch =`
@media (min-width: 576px) {
    .align-content-sm-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }
}
`;
export const align_self_sm_auto =`
@media (min-width: 576px) {
    .align-self-sm-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }
}
`;
export const align_self_sm_start =`
@media (min-width: 576px) {
    .align-self-sm-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }
}
`;
export const align_self_sm_end =`
@media (min-width: 576px) {
    .align-self-sm-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }
}
`;
export const align_self_sm_center =`
@media (min-width: 576px) {
    .align-self-sm-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }
}
`;
export const align_self_sm_baseline =`
@media (min-width: 576px) {
    .align-self-sm-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }
}
`;
export const align_self_sm_stretch =`
@media (min-width: 576px) {
    .align-self-sm-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}
`;
export const flex_md_row =`
@media (min-width: 768px) {
    .flex-md-row {
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }
}
`;
export const flex_md_column =`
@media (min-width: 768px) {
    .flex-md-column {
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }
}
`;
export const flex_md_row_reverse =`
@media (min-width: 768px) {
    .flex-md-row-reverse {
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }
}
`;
export const flex_md_column_reverse =`
@media (min-width: 768px) {
    .flex-md-column-reverse {
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }
}
`;
export const flex_md_wrap =`
@media (min-width: 768px) {
    .flex-md-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
}
`;
export const flex_md_nowrap =`
@media (min-width: 768px) {
    .flex-md-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }
}
`;
export const flex_md_wrap_reverse =`
@media (min-width: 768px) {
    .flex-md-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }
}
`;
export const flex_md_fill =`
@media (min-width: 768px) {
    .flex-md-fill {
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
    }
}
`;
export const flex_md_grow_0 =`
@media (min-width: 768px) {
    .flex-md-grow-0 {
        -ms-flex-positive: 0 !important;
        flex-grow: 0 !important;
    }
}
`;
export const flex_md_grow_1 =`
@media (min-width: 768px) {
    .flex-md-grow-1 {
        -ms-flex-positive: 1 !important;
        flex-grow: 1 !important;
    }
}
`;
export const flex_md_shrink_0 =`
@media (min-width: 768px) {
    .flex-md-shrink-0 {
        -ms-flex-negative: 0 !important;
        flex-shrink: 0 !important;
    }
}
`;
export const flex_md_shrink_1 =`
@media (min-width: 768px) {
    .flex-md-shrink-1 {
        -ms-flex-negative: 1 !important;
        flex-shrink: 1 !important;
    }
}
`;
export const justify_content_md_start =`
@media (min-width: 768px) {
    .justify-content-md-start {
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }
}
`;
export const justify_content_md_end =`
@media (min-width: 768px) {
    .justify-content-md-end {
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }
}
`;
export const justify_content_md_center =`
@media (min-width: 768px) {
    .justify-content-md-center {
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }
}
`;
export const justify_content_md_between =`
@media (min-width: 768px) {
    .justify-content-md-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
}
`;
export const justify_content_md_around =`
@media (min-width: 768px) {
    .justify-content-md-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }
}
`;
export const align_items_md_start =`
@media (min-width: 768px) {
    .align-items-md-start {
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }
}
`;
export const align_items_md_end =`
@media (min-width: 768px) {
    .align-items-md-end {
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }
}
`;
export const align_items_md_center =`
@media (min-width: 768px) {
    .align-items-md-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
}
`;
export const align_items_md_baseline =`
@media (min-width: 768px) {
    .align-items-md-baseline {
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }
}
`;
export const align_items_md_stretch =`
@media (min-width: 768px) {
    .align-items-md-stretch {
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }
}
`;
export const align_content_md_start =`
@media (min-width: 768px) {
    .align-content-md-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }
}
`;
export const align_content_md_end =`
@media (min-width: 768px) {
    .align-content-md-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }
}
`;
export const align_content_md_center =`
@media (min-width: 768px) {
    .align-content-md-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }
}
`;
export const align_content_md_between =`
@media (min-width: 768px) {
    .align-content-md-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }
}
`;
export const align_content_md_around =`
@media (min-width: 768px) {
    .align-content-md-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }
}
`;
export const align_content_md_stretch =`
@media (min-width: 768px) {
    .align-content-md-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }
}
`;
export const align_self_md_auto =`
@media (min-width: 768px) {
    .align-self-md-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }
}
`;
export const align_self_md_start =`
@media (min-width: 768px) {
    .align-self-md-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }
}
`;
export const align_self_md_end =`
@media (min-width: 768px) {
    .align-self-md-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }
}
`;
export const align_self_md_center =`
@media (min-width: 768px) {
    .align-self-md-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }
}
`;
export const align_self_md_baseline =`
@media (min-width: 768px) {
    .align-self-md-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }
}
`;
export const align_self_md_stretch =`
@media (min-width: 768px) {
    .align-self-md-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}
`;
export const flex_lg_row =`
@media (min-width: 992px) {
    .flex-lg-row {
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }
}
`;
export const flex_lg_column =`
@media (min-width: 992px) {
    .flex-lg-column {
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }
}
`;
export const flex_lg_row_reverse =`
@media (min-width: 992px) {
    .flex-lg-row-reverse {
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }
}
`;
export const flex_lg_column_reverse =`
@media (min-width: 992px) {
    .flex-lg-column-reverse {
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }
}
`;
export const flex_lg_wrap =`
@media (min-width: 992px) {
    .flex-lg-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
}
`;
export const flex_lg_nowrap =`
@media (min-width: 992px) {
    .flex-lg-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }
}
`;
export const flex_lg_wrap_reverse =`
@media (min-width: 992px) {
    .flex-lg-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }
}
`;
export const flex_lg_fill =`
@media (min-width: 992px) {
    .flex-lg-fill {
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
    }
}
`;
export const flex_lg_grow_0 =`
@media (min-width: 992px) {
    .flex-lg-grow-0 {
        -ms-flex-positive: 0 !important;
        flex-grow: 0 !important;
    }
}
`;
export const flex_lg_grow_1 =`
@media (min-width: 992px) {
    .flex-lg-grow-1 {
        -ms-flex-positive: 1 !important;
        flex-grow: 1 !important;
    }
}
`;
export const flex_lg_shrink_0 =`
@media (min-width: 992px) {
    .flex-lg-shrink-0 {
        -ms-flex-negative: 0 !important;
        flex-shrink: 0 !important;
    }
}
`;
export const flex_lg_shrink_1 =`
@media (min-width: 992px) {
    .flex-lg-shrink-1 {
        -ms-flex-negative: 1 !important;
        flex-shrink: 1 !important;
    }
}
`;
export const justify_content_lg_start =`
@media (min-width: 992px) {
    .justify-content-lg-start {
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }
}
`;
export const justify_content_lg_end =`
@media (min-width: 992px) {
    .justify-content-lg-end {
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }
}
`;
export const justify_content_lg_center =`
@media (min-width: 992px) {
    .justify-content-lg-center {
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }
}
`;
export const justify_content_lg_between =`
@media (min-width: 992px) {
    .justify-content-lg-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
}
`;
export const justify_content_lg_around =`
@media (min-width: 992px) {
    .justify-content-lg-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }
}
`;
export const align_items_lg_start =`
@media (min-width: 992px) {
    .align-items-lg-start {
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }
}
`;
export const align_items_lg_end =`
@media (min-width: 992px) {
    .align-items-lg-end {
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }
}
`;
export const align_items_lg_center =`
@media (min-width: 992px) {
    .align-items-lg-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
}
`;
export const align_items_lg_baseline =`
@media (min-width: 992px) {
    .align-items-lg-baseline {
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }
}
`;
export const align_items_lg_stretch =`
@media (min-width: 992px) {
    .align-items-lg-stretch {
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }
}
`;
export const align_content_lg_start =`
@media (min-width: 992px) {
    .align-content-lg-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }
}
`;
export const align_content_lg_end =`
@media (min-width: 992px) {
    .align-content-lg-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }
}
`;
export const align_content_lg_center =`
@media (min-width: 992px) {
    .align-content-lg-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }
}
`;
export const align_content_lg_between =`
@media (min-width: 992px) {
    .align-content-lg-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }
}
`;
export const align_content_lg_around =`
@media (min-width: 992px) {
    .align-content-lg-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }
}
`;
export const align_content_lg_stretch =`
@media (min-width: 992px) {
    .align-content-lg-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }
}
`;
export const align_self_lg_auto =`
@media (min-width: 992px) {
    .align-self-lg-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }
}
`;
export const align_self_lg_start =`
@media (min-width: 992px) {
    .align-self-lg-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }
}
`;
export const align_self_lg_end =`
@media (min-width: 992px) {
    .align-self-lg-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }
}
`;
export const align_self_lg_center =`
@media (min-width: 992px) {
    .align-self-lg-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }
}
`;
export const align_self_lg_baseline =`
@media (min-width: 992px) {
    .align-self-lg-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }
}
`;
export const align_self_lg_stretch =`
@media (min-width: 992px) {
    .align-self-lg-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}
`;
export const flex_xl_row =`
@media (min-width: 1320px) {
    .flex-xl-row {
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }
}
`;
export const flex_xl_column =`
@media (min-width: 1320px) {
    .flex-xl-column {
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }
}
`;
export const flex_xl_row_reverse =`
@media (min-width: 1320px) {
    .flex-xl-row-reverse {
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }
}
`;
export const flex_xl_column_reverse =`
@media (min-width: 1320px) {
    .flex-xl-column-reverse {
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }
}
`;
export const flex_xl_wrap =`
@media (min-width: 1320px) {
    .flex-xl-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
}
`;
export const flex_xl_nowrap =`
@media (min-width: 1320px) {
    .flex-xl-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }
}
`;
export const flex_xl_wrap_reverse =`
@media (min-width: 1320px) {
    .flex-xl-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }    
}
`;
export const flex_xl_fill =`
@media (min-width: 1320px) {
    .flex-xl-fill {
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
    }
}
`;
export const flex_xl_grow_0 =`
@media (min-width: 1320px) {
    .flex-xl-grow-0 {
        -ms-flex-positive: 0 !important;
        flex-grow: 0 !important;
    }
}
`;
export const flex_xl_grow_1 =`
@media (min-width: 1320px) {
    .flex-xl-grow-1 {
        -ms-flex-positive: 1 !important;
        flex-grow: 1 !important;
    }
}
`;
export const flex_xl_shrink_0 =`
@media (min-width: 1320px) {
    .flex-xl-shrink-0 {
        -ms-flex-negative: 0 !important;
        flex-shrink: 0 !important;
    }
}
`;
export const flex_xl_shrink_1 =`
@media (min-width: 1320px) {
    .flex-xl-shrink-1 {
        -ms-flex-negative: 1 !important;
        flex-shrink: 1 !important;
    }
}
`;
export const justify_content_xl_start =`
@media (min-width: 1320px) {
    .justify-content-xl-start {
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }
}
`;
export const justify_content_xl_end =`
@media (min-width: 1320px) {
    .justify-content-xl-end {
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }
}
`;
export const justify_content_xl_center=`
@media (min-width: 1320px) {
    .justify-content-xl-center {
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }
}
`;
export const justify_content_xl_between =`
@media (min-width: 1320px) {
    .justify-content-xl-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
}
`;
export const justify_content_xl_around =`
@media (min-width: 1320px) {
    .justify-content-xl-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }
}
`;
export const align_items_xl_start =`
@media (min-width: 1320px) {
    .align-items-xl-start {
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }
}
`;
export const align_items_xl_end =`
@media (min-width: 1320px) {
    .align-items-xl-end {
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }
}
`;
export const align_items_xl_center =`
@media (min-width: 1320px) {
    .align-items-xl-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
}
`;
export const align_items_xl_baseline =`
@media (min-width: 1320px) {
    .align-items-xl-baseline {
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }
}
`;
export const align_items_xl_stretch =`
@media (min-width: 1320px) {
    .align-items-xl-stretch {
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }
}
`;
export const align_content_xl_start =`
@media (min-width: 1320px) {
    .align-content-xl-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }
}
`;
export const align_content_xl_end =`
@media (min-width: 1320px) {
    .align-content-xl-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }
}
`;
export const align_content_xl_center =`
@media (min-width: 1320px) {
    .align-content-xl-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }
}
`;
export const align_content_xl_between =`
@media (min-width: 1320px) {
    .align-content-xl-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }
}
`;
export const align_content_xl_around =`
@media (min-width: 1320px) {
    .align-content-xl-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }
}
`;
export const align_content_xl_stretch =`
@media (min-width: 1320px) {
    .align-content-xl-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }
}
`;
export const align_self_xl_auto =`
@media (min-width: 1320px) {
    .align-self-xl-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }
}
`;
export const align_self_xl_start =`
@media (min-width: 1320px) {
    .align-self-xl-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }
}
`;
export const align_self_xl_end =`
@media (min-width: 1320px) {
    .align-self-xl-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }
}
`;
export const align_self_xl_center =`
@media (min-width: 1320px) {
    .align-self-xl-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }
}
`;
export const align_self_xl_baseline =`
@media (min-width: 1320px) {
    .align-self-xl-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }
}
`;
export const align_self_xl_stretch =`
@media (min-width: 1320px) {
    .align-self-xl-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}
`;